import React from "react";
import { JobOffersParent } from "../components/job-offers/JobOffers";

const JobOffers = () => {
  return <JobOffersParent />;
};

export default JobOffers;
